// extracted by mini-css-extract-plugin
module.exports = {"container":"Controls_container__3f87A","buttons":"Controls_buttons__cnbdX","sliders":"Controls_sliders__2jjcg","qubit":"Controls_qubit__3myQm","qubitFW":"Controls_qubitFW__2-mDI"};